export default __webpack_public_path__ + "static/media/出发_set-off.51911358.svg";